import { Helmet } from "react-helmet-async";

import { BadgeDetailsData } from "../../../../route/public/badge/details/page/useDetails";

interface PublicBadgeDetialsMetaTagsProps {
  badgeDetailsData?: BadgeDetailsData;
}

export const BadgeDetailsMetaTags = ({ badgeDetailsData }: PublicBadgeDetialsMetaTagsProps): JSX.Element | null => {
  return (
    <Helmet>
      <title>{badgeDetailsData?.displayName}</title>
      <meta name="title" content={badgeDetailsData?.displayName || undefined} />
      <meta name="description" content={badgeDetailsData?.hero?.subtitle || undefined} />
      <script type="application/ld+json">
        {JSON.stringify(
          {
            "@context": "https://schema.org",
            "@type": "Dataset",
            name: badgeDetailsData?.displayName,
            description: badgeDetailsData?.hero?.subtitle || undefined,
          },
          null,
          "\t"
        )}
      </script>
    </Helmet>
  );
};
